<p-table [scrollable]="true" [size]="'small'" [value]="invoices()" scrollHeight="flex">
  <ng-template #header>
    <tr>
      <th pResizableColumn pSortableColumn="number">{{ 'invoice.number' | translate }}
        <p-sortIcon field="number"/>
      </th>
      <th pResizableColumn pSortableColumn="customerName">{{ 'entity.customer' | translate }}
        <p-sortIcon field="customerName"/>
      </th>
      <th pResizableColumn pSortableColumn="legalEntityName">{{ 'entity.legal-entity' | translate }}
        <p-sortIcon field="legalEntityName"/>
      </th>
      <th pResizableColumn pSortableColumn="date">{{ 'invoice.invoice-date' | translate }}
        <p-sortIcon field="date"/>
      </th>
      <th pResizableColumn pSortableColumn="amountWithoutTax">{{ 'invoice.total-without-taxes' | translate }}
        <p-sortIcon field="amountWithoutTax"/>
      </th>
      <th pResizableColumn>{{ 'invoice.status' | translate }}</th>
      <th pResizableColumn>{{ 'invoice.type' | translate }}</th>
      @if (showDirectDebitExport()) {
        <th pResizableColumn pSortableColumn="directDebitExportedAt">{{ 'direct-debit.exported-at' | translate }}
          <p-sortIcon field="directDebitExportedAt"/>
        </th>
      }
      <th class="w-[100px]"></th>
    </tr>
  </ng-template>
  <ng-template #body let-invoice>
    <tr (click)="select(invoice)" [class.cursor-pointer]="isDraft(invoice)">
      <td>{{ invoice.number }}</td>
      <td>{{ invoice.customerName }}</td>
      <td>{{ invoice.legalEntityName }}</td>
      <td>{{ invoice.date | date:'dd/MM/yyyy' }}</td>
      <td>{{ invoice.amountWithoutTax | currency:'EUR' }}</td>
      <td>
        <elcia-billing-badge [state]="invoice.stateName"/>
      </td>
      <td>
        <elcia-invoice-kind-badge [kind]="invoice.invoiceType"/>
      </td>
      @if (showDirectDebitExport()) {
        <td>{{ invoice.directDebitExportedAt ? (invoice.directDebitExportedAt | date:'dd/MM/yyyy') : '—' }}</td>
      }
      <td class="flex justify-end gap-2">
        @if (canCredit(invoice)) {
          <elcia-button (onClick)="credit(invoice)" [icon]="'credit-note'" [severity]="'secondary'"
                        [tooltip]="'action.credit' | translate" [variant]="'text'"/>
        }
        @if (canDelete(invoice)) {
          <elcia-button (onClick)="delete($event, invoice)" [icon]="'delete'" [severity]="'danger'"
                        [tooltip]="'action.delete' | translate" [variant]="'text'"/>
        }
      </td>
    </tr>
  </ng-template>
</p-table>
